// extracted by mini-css-extract-plugin
export default {"deleteDialogBody":"XSF6vHHPTcNOJAdFN2Cw"};